import { IonContent } from '@ionic/react';
import classNames from 'classnames';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { UiTypography } from '@/components/ui/Typography';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { queryParamsModule } from '@/modules/queryParams';
import { webCampaign } from '@/modules/webCampaign';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { AI_DATA } from '@/pages/Onboarding/constants';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataKeyType, LayoutDataType } from '../../types';

import { OPTIONS } from './constants';
import { ReplikaGenderStyles } from './Gender.styles';

export const OnboardingReplikaGender: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Gender',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  const aiData = AI_DATA[webCampaign.aiType];

  const handleClick = (option: OnbOptionType<LayoutDataType['gender']>) => {
    userService.createOrUpdate({
      onboarding_data: {
        gender: option.title,
      },
    });
    form.setValue('gender', option.id);
    queryParamsModule.setParam<LayoutDataKeyType>('gender', option.id);
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <ReplikaGenderStyles>
      <LogoWithAppName />

      <OnboardingTitle color="black" className="local-title">
        Welcome to the most exciting AI universe for your self-expression
      </OnboardingTitle>

      <IonContent>
        {aiData && (
          <div className="image-container">
            <img alt="AI" src={aiData.greet.imageSrc} />
          </div>
        )}
        <div className="onboarding-gender-options">
          {OPTIONS.map((option) => (
            <div
              key={option.id}
              onClick={() => handleClick(option)}
              className={classNames('onboarding-gender-options-item', {
                selected: option.id === gender,
              })}
            >
              <UiTypography
                variant="body-medium"
                color="neutral-white"
                align="center"
              >
                I am a
              </UiTypography>
              <UiTypography variant="body-large" color="white" align="center">
                {option.title}
              </UiTypography>
            </div>
          ))}
        </div>
      </IonContent>
    </ReplikaGenderStyles>
  );
};
